import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

// Export feature stores


interface AppState {
  // User preferences
  theme: 'light' | 'dark' | 'system';
  sidebarCollapsed: boolean;
  preferredView: 'grid' | 'list';
  
  // Global filters
  globalEntityFilter: string | null;
  globalDateRange: { from: Date | null; to: Date | null };
  
  // UI state
  globalSearchQuery: string;

  // Actions
  setTheme: (theme: 'light' | 'dark' | 'system') => void;
  toggleSidebar: () => void;
  setPreferredView: (view: 'grid' | 'list') => void;
  setGlobalEntityFilter: (entityCode: string | null) => void;
  setGlobalDateRange: (range: { from: Date | null; to: Date | null }) => void;
  setGlobalSearchQuery: (query: string) => void;
  resetFilters: () => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        // Initial state
        theme: 'light',
        sidebarCollapsed: false,
        preferredView: 'list',
        globalEntityFilter: null,
        globalDateRange: { from: null, to: null },
        globalSearchQuery: '',

        // Actions
        setTheme: (theme) => set({ theme }),
        toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
        setPreferredView: (view) => set({ preferredView: view }),
        setGlobalEntityFilter: (entityCode) => set({ globalEntityFilter: entityCode }),
        setGlobalDateRange: (range) => set({ globalDateRange: range }),
        setGlobalSearchQuery: (query) => set({ globalSearchQuery: query }),
        resetFilters: () => set({ 
          globalEntityFilter: null, 
          globalDateRange: { from: null, to: null },
          globalSearchQuery: ''
        }),
      }),
      {
        name: 'app-storage',
        partialize: (state) => ({
          theme: state.theme,
          sidebarCollapsed: state.sidebarCollapsed,
          preferredView: state.preferredView,
        }),
      }
    )
  )
);